import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { BuildingSelectFormikField } from '../../../Building'
import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../Formik'
import Text from '../../../Text'
import {
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS,
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING,
  USER_EDIT_ADDRESS_FORM_MODAL_INITIAL_VALUES,
} from '../UserEditAddressFormModal.constants'
import { getUserEditAddressFormModalItemActionTypes } from '../UserEditAddressFormModal.utils'
import { UserEditAddressFormModalFlatTagList } from '../UserEditAddressFormModalFlatTagList'

import { FlatField } from './FlatField'

import * as styles from './UserEditAddressFormModalFields.module.css'

function UserEditAddressFormModalFields({ isLoading }) {
  const { t } = useTranslation()

  const { isSubmitting, setFieldValue, values } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: USER_EDIT_ADDRESS_FORM_MODAL_INITIAL_VALUES,
    })

  const addedFlats = values[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS]

  function handleSetAddress(items) {
    setFieldValue(USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS, items)
  }

  return (
    <FormFieldsContainer className={styles.formFieldsContainer}>
      <div className={styles.actionRow}>
        <FormikEntityActionConfigFields
          typeSelectProps={{
            options: getUserEditAddressFormModalItemActionTypes(),
          }}
        />
      </div>
      <div className={styles.formFieldsWrapper}>
        <div className={styles.column}>
          <Text>{t('User.SelectAddressKey')}</Text>
          <BuildingSelectFormikField
            Field={FieldStackedLabel}
            controlProps={{
              contentProps: {
                inputProps: {
                  autoFocus: true,
                  placeholder: t('User.BuildingPlaceholderKey'),
                },
              },
            }}
            disabled={actionTypeValueIsRemoveAll}
            fieldComponentProps={{
              isLoading,
              label: `${t('User.BuildingLabelKey')}:`,
            }}
            name={USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING}
          />
          <FlatField
            disabled={actionTypeValueIsRemoveAll}
            isLoading={isLoading}
          />
        </div>
        <div className={styles.separator} />
        <div className={styles.column}>
          <div className={styles.addedAddressHeader}>
            <Text>{t('User.AddedAddressKey')}</Text>
          </div>
          <div className={styles.addedAddressList}>
            {addedFlats.length > 0 ? (
              <UserEditAddressFormModalFlatTagList
                disabled={isSubmitting}
                items={addedFlats}
                onSetAddress={handleSetAddress}
                onSetFieldValue={setFieldValue}
              />
            ) : (
              <div className={styles.emptyAddress}>
                <Text isSecondary>{t('User.EmptyAddedAddressKey')}</Text>
              </div>
            )}
          </div>
        </div>
      </div>
    </FormFieldsContainer>
  )
}

export default UserEditAddressFormModalFields
